import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./assets/Styles/styleAccueil.css";

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ParticlesBackground from "./components/ParticlesBackgrounds";
import { Accueil } from "./components/Accueil";
import Blog from './pages/blog';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* Fond animé */}
        <ParticlesBackground />

        <Routes>
          {/* Page d'accueil de ton portfolio */}
          <Route path="/" element={<Accueil />} />
          <Route path="/blog" element={<Blog />} />
        
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
